import { useEffect, useState } from "react";
import { FaEnvelope, FaLock, FaUser, FaPhone, FaTimes } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { v4 as uuidv4 } from "uuid";
import Loader from "../components/loader";
import "./OwnerAddUserModal.css";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export default function OwnerAddUserModal({ onClose, onSuccess }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [verificationToken, setVerificationToken] = useState(null);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);

  /* ================= Timer ================= */
  useEffect(() => {
    let interval;
    if (showVerifyModal && timer > 0) {
      interval = setInterval(() => setTimer((t) => t - 1), 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [showVerifyModal, timer]);



  const handleResend = async () => {
    if (!canResend) return;
    setTimer(30);
    setCanResend(false);
    await sendVerificationEmail(
      formData.name,
      formData.email,
      verificationToken
    );
  };

  /* ================= Handlers ================= */
  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

/* ================= Email Logic ================= */
const sendVerificationEmail = async (name, email, token) => {
  // Point to the root verification route so it triggers the Home page logic
  const link = `${window.location.origin}/verify-email/${token}`;

  await emailjs.send(
    "service_5u1kekh",
    "template_3j87dpi",
    {
      to_name: name,
      user_email: email,
      verification_link: link,
    },
    "5C9M_B-DFS8qIhtRl"
  );
};

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setError("");

  try {
    const userId = uuidv4().replace(/-/g, "").slice(0, 16);

    // Ensure this route matches your user signup backend logic
    const res = await fetch(`${BASE_URL}/auth/signup`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...formData, userId }),
    });

    const data = await res.json();

    if (!res.ok) {
      setError(data.message || "Signup failed");
      setLoading(false);
      return;
    }

    if (data.verificationToken) {
      setVerificationToken(data.verificationToken);

      // Important: Metadata for the Home page to auto-open login
      localStorage.setItem("verificationRole", "user");
      localStorage.setItem("verificationEmail", formData.email);

      await sendVerificationEmail(
        formData.name,
        formData.email,
        data.verificationToken
      );

      setShowVerifyModal(true);
    }
  } catch {
    setError("Something went wrong");
  }
  setLoading(false);
};
  if (loading) return <Loader />;

return (
  <div className="owner-modal-overlay-add-user">
    <div className="owner-auth-card-add-user">

      {/* ❌ Close */}
      <FaTimes className="owner-modal-close-icon-add-user" onClick={onClose} />

      {showVerifyModal ? (
        /* ================= VERIFY (WHITE MODAL) ================= */
        <div className="owner-verify-content-add-user">
          <h2 className="owner-auth-title-add-user">Email Verification</h2>

          <p className="owner-auth-subtitle-add-user add-user">
            Verification link sent to <b>{formData.email}</b>
          </p>

          <button
            disabled={!canResend}
            onClick={handleResend}
            className="owner-auth-btn-add-user"
          >
            {canResend ? "Resend Email" : `Resend (${timer}s)`}
          </button>
        </div>
      ) : (
        /* ================= FORM ================= */
        <form onSubmit={handleSubmit}>
          <h2 className="owner-auth-title-add-user">Create User</h2>

          <div className="owner-auth-input-add-user">
            <FaUser />
            <input
              name="name"
              placeholder="User Name"
              onChange={handleChange}
              required
            />
          </div>

          <div className="owner-auth-input-add-user">
            <FaEnvelope />
            <input
              name="email"
              type="email"
              placeholder="User Email"
              onChange={handleChange}
              required
            />
          </div>

          <div className="owner-auth-input-add-user">
            <FaPhone />
            <input
              name="mobile"
              placeholder="Mobile Number"
              onChange={handleChange}
              required
            />
          </div>

          <div className="owner-auth-input-add-user">
            <FaLock />
            <input
              name="password"
              type="password"
              placeholder="Password"
              onChange={handleChange}
              required
            />
          </div>

          {error && <p className="owner-auth-error-add-user">{error}</p>}

          <button className="owner-auth-btn-add-user">Create User</button>
        </form>
      )}
    </div>
  </div>
);

}
